import { PaginatedResponse } from './index';

export type ScoreOperator =
  | 'eq'
  | 'neq'
  | 'in'
  | 'not_in'
  | '>'
  | '>='
  | '<'
  | '<='
  | 'contains'
  | 'exists';

export const SCORE_OPERATORS: ScoreOperator[] = [
  'eq',
  'neq',
  'in',
  'not_in',
  '>',
  '>=',
  '<',
  '<=',
  'contains',
  'exists',
];

export const SCORE_OPERATOR_LABEL: Record<ScoreOperator, string> = {
  eq: '= (uguale)',
  neq: '≠ (diverso)',
  in: 'in [...] (tra)',
  not_in: 'not in',
  '>': '>',
  '>=': '≥',
  '<': '<',
  '<=': '≤',
  contains: 'contiene',
  exists: 'è presente',
};

// Campi comuni disponibili per scoring (lato backend + virtuali)
export const SCORE_RULE_FIELDS: { value: string; label: string; hasDaysTypes?: boolean }[] = [
  { value: 'stato', label: 'Stato' },
  { value: 'source', label: 'Origine' },
  { value: 'tipo', label: 'Tipo (persona/azienda)' },
  { value: 'score', label: 'Score corrente' },
  { value: 'agente_id', label: 'Agente assegnato' },
  { value: 'email', label: 'Email' },
  { value: 'telefono', label: 'Telefono' },
  { value: 'pec', label: 'PEC' },
  { value: 'partita_iva', label: 'P.IVA' },
  { value: 'codice_fiscale', label: 'Codice fiscale' },
  { value: 'citta', label: 'Città' },
  { value: 'provincia', label: 'Provincia' },
  { value: 'utm_source', label: 'UTM source' },
  { value: 'utm_medium', label: 'UTM medium' },
  { value: 'utm_campaign', label: 'UTM campaign' },
  {
    value: 'activity_count_last_days',
    label: 'Attività negli ultimi N giorni',
    hasDaysTypes: true,
  },
  { value: 'days_since_last_activity', label: 'Giorni dall’ultima attività' },
];

export interface ConditionLeaf {
  field: string;
  op: ScoreOperator;
  value?: unknown;
  days?: number;
  types?: string[];
}

export interface ConditionGroup {
  all?: Condition[];
  any?: Condition[];
}

export type Condition = ConditionLeaf | ConditionGroup;

export interface LeadScoreRuleBase {
  name: string;
  description?: string | null;
  conditions: Record<string, unknown>;
  points: number;
  is_active: boolean;
  priority: number;
}

export interface LeadScoreRuleResponse extends LeadScoreRuleBase {
  id: string;
  tenant_id: string;
  created_at: string;
  updated_at?: string | null;
  created_by?: string | null;
  updated_by?: string | null;
  is_deleted: boolean;
}

export interface LeadScoreRuleCreate {
  name: string;
  description?: string;
  conditions: Record<string, unknown>;
  points: number;
  is_active?: boolean;
  priority?: number;
}

export interface LeadScoreRuleUpdate {
  name?: string;
  description?: string;
  conditions?: Record<string, unknown>;
  points?: number;
  is_active?: boolean;
  priority?: number;
}

export interface LeadScoreRuleListResponse extends PaginatedResponse<LeadScoreRuleResponse> {}

export interface ScoreChangeResponse {
  lead_id: string;
  old_score: number;
  new_score: number;
  delta: number;
}

export interface RecomputeAllResponse {
  total: number;
  changed: number;
  unchanged: number;
}

export interface ToggleResponse {
  id: string;
  is_active: boolean;
}
